import { render } from "./EmployeeDocumentsView.vue?vue&type=template&id=3e877b34&scoped=true"
import script from "./EmployeeDocumentsView.vue?vue&type=script&lang=js"
export * from "./EmployeeDocumentsView.vue?vue&type=script&lang=js"

import "./EmployeeDocumentsView.vue?vue&type=style&index=0&id=3e877b34&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e877b34"]])

export default __exports__